import { useEffect, useState } from "react";
import { FormLayout, Modal, TextField } from "@shopify/polaris";
import { printPalletLabels } from "../../../shared/dymo/labels/pallet_labels/palletLabel";

function parseExternalPayload(externalPayload) {
  if (!externalPayload) return null;

  try {
    return JSON.parse(externalPayload);
  } catch (error) {
    return null;
  }
}

function getPayloadCustomerName(payload) {
  const payloadCustomerName = [payload?.customer?.firstName, payload?.customer?.lastName].filter(Boolean).join(" ").trim();

  return payload?.order?.shipping_address?.company || payload?.customer?.company || payloadCustomerName || "";
}

function getInitialFormState(order) {
  const payload = parseExternalPayload(order?.ExternalPayload);

  return {
    copies: "2",
    orderNumber: String(order?.order_number ?? payload?.order?.increment_id ?? ""),
    customerReference: String(order?.reference_customer ?? payload?.order?.increment_id ?? ""),
    customerName: String(order?.customer?.company_name ?? order?.delivery_address?.company_name ?? order?.invoicing_address?.company_name ?? getPayloadCustomerName(payload) ?? ""),
  };
}

export const PalletLabelPrintModal = ({ open, onClose, order }) => {
  const [formState, setFormState] = useState(getInitialFormState(order));
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    if (open) setFormState(getInitialFormState(order));
  }, [open, order]);

  const handleChange = (field) => (value) => {
    setFormState((currentState) => ({
      ...currentState,
      [field]: value,
    }));
  };

  const handlePrint = () => {
    setIsPrinting(true);

    try {
      printPalletLabels(formState);
      onClose();
    } finally {
      setIsPrinting(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Print pallet label"
      primaryAction={{ content: "Print pallet label", onAction: handlePrint, loading: isPrinting }}
      secondaryActions={[{ content: "Cancel", onAction: onClose }]}
    >
      <Modal.Section>
        <FormLayout>
          <TextField
            label="Number of prints"
            type="number"
            autoComplete="off"
            value={formState.copies}
            onChange={handleChange("copies")}
            helpText="Defaults to 2 labels."
          />
          <TextField label="Order number" autoComplete="off" value={formState.orderNumber} onChange={handleChange("orderNumber")} />
          <TextField label="Customer ref." autoComplete="off" value={formState.customerReference} onChange={handleChange("customerReference")} />
          <TextField label="Customer name" autoComplete="off" value={formState.customerName} onChange={handleChange("customerName")} />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );
};
